export default __webpack_public_path__ + "static/media/wallDecor.cd55f5e7.jpg";